'use strict';

import appStore from './AppStore';

const httpClient = appStore.getHttpClient();

class Api {
    constructor() {
        this.baseUrl = "api";
    }

    getNotices() {
        return httpClient.doGet(`${this.baseUrl}/notice/notices`, 'getNotices', true);
    }

    getRegistration(termId) {
        return httpClient.doGet(`${this.baseUrl}/registration/${termId}`, 'getRegistration');
    }

    postRegistration(termId, postBody) {
        return httpClient.doPost(`${this.baseUrl}/registration/${termId}`, postBody, 'postRegistration');
    }

    getPreRegStatus(termId) {
        return httpClient.doGet(`${this.baseUrl}/preregStatus/${termId}`, 'getPreRegStatus');
    }

    getAcknowledgements(params) {
        let url;
        if ( (appStore.isBackdoorAllowed() || appStore.isDevMode()) && params ) {
            url = `${this.baseUrl}/acknowledgements${params}`
        } else {
            url = `${this.baseUrl}/acknowledgements`
        }
        return httpClient.doGet(url, 'getAcknowledgements');
    }

    updateAcknowledgements(postBody) {
        return httpClient.doPost(`${this.baseUrl}/acknowledgements`, postBody, 'updateAcknowledgements');
    }

    getOptionalCharges(termId) {
        return httpClient.doGet(`${this.baseUrl}/optcharges/${termId}`, 'getOptionalCharges');
    }

    updateOptionalCharges(postBody) {
        return httpClient.doPost(`${this.baseUrl}/optcharges`, postBody, 'updateOptionalCharges');
    }

    getAddress() {
        return httpClient.doGet(`${this.baseUrl}/address`, 'getAddress');
    }

    updateAddress(postBody) {
        return httpClient.doPost(`${this.baseUrl}/address`, postBody, 'updateAddress');
    }
}

export default new Api();